import React, { useEffect } from "react";
import { Button, Modal, Form, Input, message, Radio } from "antd";
import API from "../../../../services/api-request";
import SelectProductType from "../../../../components/SelectProductType";

const EditProduct = (props) => {
  const [editForm] = Form.useForm();

  const options = [
    { label: "Ya", value: 1 },
    { label: "Tidak", value: 0 },
  ];

  const onFinish = async (values) => {
    const { product_type_id, name, description, show_in_dashboard } = values;

    const dataForm = {
      product_type_id,
      name,
      description,
      show_in_dashboard,
    };

    await API.Put(`product/${props.selectedData.id}`, dataForm)
      .then(() => {
        message.success("Product has been edited");
        props.onGetProduct();
        editForm.resetFields();
        props.onShowEdit(false);
      })
      .catch((err) => {
        console.log(err);
        message.info(`${err?.response?.data?.error}`);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowEdit(false);
    editForm.resetFields();
  };

  useEffect(() => {
    editForm.setFieldsValue(props.selectedData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedData]);

  useEffect(() => {
    if (!props.showEdit) {
      editForm.resetFields();
    }
  }, [props.showEdit]);

  return (
    <Modal
      title="Edit Product"
      open={props.showEdit}
      onCancel={handleCancel}
      footer={[
        <Button key="back" type="default" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={() => editForm.submit()}>
          Save
        </Button>,
      ]}
    >
      <Form
        form={editForm}
        name="Edit Form"
        style={{
          margin: "0 auto",
        }}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="Product Type"
          name="product_type_id"
          rules={[{ required: true, message: "Please input product type!" }]}
        >
          <SelectProductType />
        </Form.Item>
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input name!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Description" name="description">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditProduct;
